<mb-communication>
  <mb-communication-info-icon></mb-communication-info-icon>
  <mb-communication-message>
    <div mb-expandable-text height="32px">
      <p class="banner-text">{{ data.text }}</p>
      <span mb-expand i18n="@@ver_mas">Ver mas</span>
      <span mb-collapse i18n="@@ver_menos">Ver menos</span>
    </div>
  </mb-communication-message>
</mb-communication>
